import DexfVpcService from '../../services/vpc/dexf/DexfVpcService.js';
import DexfConfiguration from '../../utilities/DexfConfiguration.js';
/**
 * This class is used as a simple interface for VPC services.
 */
export default class VpcService {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    constructor(options) {
        this.applicationName = options.applicationName;
        this.dexfApplicationId = options.dexfApplicationId || null;
        this.dexfConfigurationVersion = options.dexfConfigurationVersion;
        this.dexfIcfVersion = options.dexfIcfVersion;
        this.dexfConfiguration = new DexfConfiguration(options);
    }
    /**
     * Saves a planner configuration.
     *
     * @param configuration Configuration to save.
     * @param shoppingItems Product items.
     * @param [configurationImage] Configuration image as a base 64 string (e.g. "data:image/jpeg;base64,abc..").
     * @param insightsCombinationFormat Insights Combination Format.
     * @returns Promise object.
     */
    async saveConfiguration(configuration, shoppingItems, configurationImage, insightsCombinationFormat) {
        const service = await this.getService();
        return await service.saveConfiguration(configuration, shoppingItems, configurationImage, insightsCombinationFormat);
    }
    /**
     * Fetches and returns a planner configuration.
     *
     * @param id Configuration ID (VPC Code).
     * @param options ...
     * @param options.includeIcfData Whether to include ICF data in the response or not.
     * @returns Promise object.
     */
    async getConfiguration(id, options) {
        const service = await this.getService();
        return await service.getConfiguration(id, options);
    }
    /**
     * Returns service.
     *
     * @returns Service.
     */
    async getService() {
        const { kompis } = await this.dexfConfiguration.getSettings();
        const dexfApiKey = await this.dexfConfiguration.getDexfApiKeyOrThrow();
        return new DexfVpcService({
            endpoint: kompis.endpoints.dexfVpcService,
            dexfApplicationId: this.dexfApplicationId || this.applicationName,
            dexfApiKey,
            dexfConfigurationVersion: this.dexfConfigurationVersion,
            dexfIcfVersion: this.dexfIcfVersion
        });
    }
}
//# sourceMappingURL=VpcService.js.map